// extracted by mini-css-extract-plugin
export const closeLines = "style-module--closeLines--NH-MC";
export const question = "style-module--question--1VeNy";
export const registrationButton = "style-module--registrationButton--3Dx5T";